import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, HostListener, Inject, Input, PLATFORM_ID, Renderer2 } from '@angular/core';

@Directive({
  selector: '[lazyLoadImage]',
  standalone: true
})
export class LazyLoadImageDirective implements AfterViewInit {
  loaded = false;
  @Input() url = '';
  @Input() defaultUrl = './assets/img/icons/iphone-spinner.gif';
  @Input() img = true;
  @Input() containerSelector;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: object
    ) {
    
  }

  ngAfterViewInit(): void {
    this.setUrl();
    setTimeout(() => this.setUrl());
    if (!isPlatformBrowser(this.platformId)) return;
    const scrollContainer = document.querySelector(this.containerSelector || '.product-list-custom-scroll-container');
    scrollContainer?.addEventListener('scroll', () => {
      this.setUrl();
    });
  }

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    if(!this.containerSelector) {
      this.setUrl();
    }
  }

  setUrl() {
    if (!isPlatformBrowser(this.platformId)) {
      if (this.img && this.url) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.url);
      }
      return;
    }
    if(this.loaded && this.el.nativeElement.className.includes('Q_ITEM_LOADED')) {
     return;
    }
    const visible = this.isInViewport(this.el.nativeElement);
    if(visible && this.url) {
     this.loaded = true;
     this.renderer.addClass(this.el.nativeElement, 'Q_ITEM_LOADED');
    }
    if(this.img) {
      this.renderer.addClass(this.el.nativeElement.parentElement, 'qatch-skeleton');
      if(visible && this.url) {
        this.renderer.setAttribute(this.el.nativeElement, 'src', this.url);
        setTimeout(() => {
          this.renderer.removeClass(this.el.nativeElement.parentElement, 'qatch-skeleton');
        }, 500);
      }
    } else {
      this.renderer.setStyle(this.el.nativeElement, 'background-size', `${visible ? 'cover' : 'auto'}`);
      this.renderer.setStyle(this.el.nativeElement, 'background-image', `url('${visible ? this.url : this.defaultUrl}')`);
    }
  }

  private isInViewport(el) {
    if(!el || !window || !document) {
      return false;
    }
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        ((rect.bottom - rect.height) <= (window.innerHeight || document.documentElement.clientHeight)) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

}
